module.exports = __webpack_public_path__ + "static/media/eye.7bc764ee.svg";